import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  FaSearch,
  FaPlus,
  FaEdit,
  FaTrash,
  FaChevronLeft,
  FaChevronRight,
} from 'react-icons/fa';

const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('adminToken');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`/api/admin/user`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { page: currentPage, search: searchTerm },
        });
        setUsers(response.data.users);
        setTotalPages(response.data.totalPages);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching users:', error);
        setLoading(false);
      }
    };

    fetchUsers();
  }, [currentPage, searchTerm, token]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleDelete = async (userId) => {
    if (window.confirm('Are you sure you want to delete this user?')) {
      try {
        await axios.delete(`/api/admin/user/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUsers(users.filter((user) => user._id !== userId));
      } catch (error) {
        console.error('Error deleting user:', error);
      }
    }
  };

  const handleEdit = (userId) => {
    navigate(`/admin/user/edit/${userId}`);
  };

  const handleCreate = () => {
    navigate('/admin/user/create');
  };

  return (
    <div className='p-4'>
      <div className='flex justify-between items-center mb-4'>
        <h1 className='text-2xl font-bold'>Users</h1>
        <button
          onClick={handleCreate}
          className='bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded flex items-center'
        >
          <FaPlus className='mr-2' /> Create User
        </button>
      </div>
      <div className='flex mb-4'>
        <input
          type='text'
          placeholder='Search by name or email...'
          value={searchTerm}
          onChange={handleSearch}
          className='border p-2 rounded w-full'
        />
        <button className='ml-2 bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded'>
          <FaSearch />
        </button>
      </div>
      {loading ? (
        <div>Loading...</div>
      ) : (
        <div>
          <table className='w-full table-auto'>
            <thead>
              <tr>
                <th className='px-4 py-2'>Name</th>
                <th className='px-4 py-2'>Email</th>
                <th className='px-4 py-2'>Role</th>
                <th className='px-4 py-2'>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user._id}>
                  <td className='border px-4 py-2'>{user.name}</td>
                  <td className='border px-4 py-2'>{user.email}</td>
                  <td className='border px-4 py-2'>{user.role}</td>
                  <td className='border px-4 py-2'>
                    <button
                      onClick={() => handleEdit(user._id)}
                      className='bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded mr-2'
                    >
                      <FaEdit />
                    </button>
                    <button
                      onClick={() => handleDelete(user._id)}
                      className='bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded'
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className='flex justify-between items-center mt-4'>
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className='bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded'
            >
              <FaChevronLeft />
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
              className='bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded'
            >
              <FaChevronRight />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminUsers;

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import Pagination from '../Common/Pagination';

// const AdminUsers = () => {
//   const [users, setUsers] = useState([]);
//   const [search, setSearch] = useState('');
//   const [role, setRole] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const token = localStorage.getItem('adminToken');

//   useEffect(() => {
//     fetchUsers();
//   }, [currentPage, search, role]);

//   const fetchUsers = async () => {
//     try {
//       const response = await axios.get('/api/admin/users', {
//         headers: { Authorization: `Bearer ${token}` },
//         params: { page: currentPage, search, role },
//       });
//       setUsers(response.data.users);
//       setTotalPages(response.data.totalPages);
//     } catch (error) {
//       console.error('Error fetching users:', error);
//     }
//   };

//   const handleSearchChange = (e) => {
//     setSearch(e.target.value);
//   };

//   const handleRoleChange = (e) => {
//     setRole(e.target.value);
//   };

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   return (
//     <div className='container mx-auto px-4 py-8'>
//       <h1 className='text-2xl font-bold mb-6'>Users</h1>
//       <div className='mb-4 flex justify-between'>
//         <input
//           type='text'
//           value={search}
//           onChange={handleSearchChange}
//           placeholder='Search users...'
//           className='p-2 border rounded'
//         />
//         <select
//           value={role}
//           onChange={handleRoleChange}
//           className='p-2 border rounded'
//         >
//           <option value=''>All Roles</option>
//           <option value='owner'>Owner</option>
//           <option value='admin'>Admin</option>
//         </select>
//       </div>
//       <table className='w-full bg-white shadow-lg rounded-lg'>
//         <thead>
//           <tr>
//             <th className='py-2 px-4'>Name</th>
//             <th className='py-2 px-4'>Email</th>
//             <th className='py-2 px-4'>Role</th>
//             <th className='py-2 px-4'>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {users.map((user) => (
//             <tr key={user._id}>
//               <td className='py-2 px-4'>{user.name}</td>
//               <td className='py-2 px-4'>{user.email}</td>
//               <td className='py-2 px-4'>{user.role}</td>
//               <td className='py-2 px-4'>
//                 {/* Actions such as Edit and Delete */}
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//       <Pagination
//         currentPage={currentPage}
//         totalPages={totalPages}
//         onPageChange={handlePageChange}
//       />
//     </div>
//   );
// };

// export default AdminUsers;

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Link } from 'react-router-dom';
// import { FaTrash, FaEdit, FaUserPlus } from 'react-icons/fa';
// import ConfirmDialog from '../Common/ConfirmDialog';

// const AdminUsers = () => {
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [isDialogOpen, setIsDialogOpen] = useState(false);
//   const [selectedUserId, setSelectedUserId] = useState(null);
//   const token = localStorage.getItem('adminToken');

//   useEffect(() => {
//     const fetchUsers = async () => {
//       try {
//         const response = await axios.get('/api/admin/users', {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setUsers(response.data);
//         setLoading(false);
//       } catch (err) {
//         setError(err.message);
//         setLoading(false);
//       }
//     };

//     fetchUsers();
//   }, [token]);

//   const handleDelete = async () => {
//     try {
//       await axios.delete(`/api/admin/users/${selectedUserId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setUsers(users.filter((user) => user._id !== selectedUserId));
//       setIsDialogOpen(false);
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   if (loading) return <div>Loading...</div>;
//   if (error) return <div className='text-red-500'>{error}</div>;

//   return (
//     <div className='container mx-auto px-4 py-8'>
//       <h1 className='text-3xl font-bold mb-6'>Users</h1>
//       <div className='mb-4'>
//         <Link
//           to='/admin/users/create'
//           className='bg-green-500 text-white py-2 px-4 rounded hover:bg-green-700 transition duration-200 inline-flex items-center'
//         >
//           <FaUserPlus className='mr-2' /> Create User
//         </Link>
//       </div>
//       <div className='bg-white shadow-md rounded-lg overflow-hidden'>
//         <table className='min-w-full bg-white'>
//           <thead>
//             <tr>
//               <th className='py-2 px-4 border-b border-gray-200'>Name</th>
//               <th className='py-2 px-4 border-b border-gray-200'>Email</th>
//               <th className='py-2 px-4 border-b border-gray-200'>Role</th>
//               <th className='py-2 px-4 border-b border-gray-200'>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {users.map((user) => (
//               <tr key={user._id}>
//                 <td className='py-2 px-4 border-b border-gray-200'>
//                   {user.name}
//                 </td>
//                 <td className='py-2 px-4 border-b border-gray-200'>
//                   {user.email}
//                 </td>
//                 <td className='py-2 px-4 border-b border-gray-200'>
//                   {user.role}
//                 </td>
//                 <td className='py-2 px-4 border-b border-gray-200'>
//                   <Link
//                     to={`/admin/users/${user._id}/edit`}
//                     className='bg-blue-500 text-white py-1 px-3 rounded hover:bg-blue-700 transition duration-200 mr-2'
//                   >
//                     <FaEdit />
//                   </Link>
//                   <button
//                     onClick={() => {
//                       setSelectedUserId(user._id);
//                       setIsDialogOpen(true);
//                     }}
//                     className='bg-red-500 text-white py-1 px-3 rounded hover:bg-red-700 transition duration-200'
//                   >
//                     <FaTrash />
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       <ConfirmDialog
//         isOpen={isDialogOpen}
//         title='Delete User'
//         message='Are you sure you want to delete this user? This action cannot be undone.'
//         onConfirm={handleDelete}
//         onCancel={() => setIsDialogOpen(false)}
//       />
//     </div>
//   );
// };

// export default AdminUsers;
